<script setup lang="ts">
import { RevisionAnnotation } from "types/RevisionAnnotation";

const { annotation, disabled } = defineProps({
  annotation: {
    type: Object as PropType<RevisionAnnotation>,
    required: false,
  },
  tooltip: {
    type: String,
    required: false,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  showSpinner: {
    type: Boolean,
    required: false,
  },
});

const emit = defineEmits(["quickCommentClicked", "click"]);

const menuRef = ref();

const onClickComment = (
  comment: string,
  annotation: RevisionAnnotation | undefined
) => {
  emit("quickCommentClicked", comment, annotation);
};

const dialogController = useNewDialogController();

const onClick = () => {
  if (disabled) {
    return;
  }

  emit("click");

  dialogController.value.close();
};
</script>

<template>
  <span>
    <BasePopover
      ref="menuRef"
      side="left"
      :trigger-methods="['hover']"
      no-auto-focus
      :controller="dialogController"
    >
      <div
        @mousedown.prevent
        @click.stop.prevent="onClick"
        class="relative cursor-pointer active:bg-medium-tint active:bg-opacity-40 hover:bg-medium-tint hover:bg-opacity-20 flex items-center justify-center w-[40px] h-[50px]"
        :class="{
          'hover:bg-surface text-medium-default': disabled,
        }"
      >
        <slot />
        <div
          v-if="showSpinner"
          class="flex rounded items-center justify-center absolute top-0 left-0 w-full h-full bg-slate-100 bg-opacity-50"
        >
          <icon name="svg-spinners:ring-resize" />
        </div>
      </div>
      <template #content>
        <div class="flex flex-col p-1" v-if="annotation">
          <span
            v-if="useAnnotationType(annotation.type)?.showDefaultSymbol == true"
            :key="useAnnotationType(annotation.type)!.inlineSymbol"
            class="p-2 cursor-pointer hover:bg-light-default"
            @mousedown.prevent
            @click="
            () => {
              dialogController.close();

              if(!annotation) {
                return;
              }
              onClickComment(useAnnotationType(annotation.type)!.inlineSymbol ?? '', annotation);
            }
          "
          >
            {{ useAnnotationType(annotation.type)!.inlineSymbol }}
          </span>
          <span
            v-for="(comment, index) in annotation.quickComments"
            :key="index"
            class="p-2 cursor-pointer hover:bg-light-default rounded"
            @mousedown.prevent
            @click="
              () => {
                dialogController.close();
                onClickComment(comment, annotation);
              }
            "
          >
            {{ comment }}
          </span>
        </div>
      </template>
    </BasePopover>
  </span>
</template>

<style scoped></style>
